export default angular
  .module("ModifyJournalCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("ModifyJournalController", [
    "$scope",
    "journalData",
    "$state",
    "$modalInstance",
    "$modal",
    "$stateParams",
    "$http",
    "$rootScope",
    "$translate",
    "Scripts",
    "System",
    function (
      $scope,
      journalData,
      $state,
      $modalInstance,
      $modal,
      $stateParams,
      $http,
      $rootScope,
      $translate,
      Scripts,
    ) {
      $scope.journal = {
        SCRIPT_ID: journalData.SCRIPT_ID,
        ID: journalData.ID,
        PUBMED_ID: journalData.PUBMED_ID,
        TITLE: journalData.TITLE,
        AUTHORS: journalData.AUTHORS,
        REF: journalData.REF,
        ALIAS: journalData.ALIAS,
      };

      const originalAlias = journalData.ALIAS;
      const originalId = journalData.PUBMED_ID;

      const aliasChanged = () =>
        originalAlias !== $scope.journal.ALIAS;

      const pubmedIdChanged = () =>
        originalId !== $scope.journal.PUBMED_ID;

      $scope.ok = function () {
        if (pubmedIdChanged() || aliasChanged()) {
          $rootScope.changedFields.set("journal", true);
        }
        $modalInstance.close($scope.journal);
      };
      $scope.cancel = function () {
        $modalInstance.dismiss("cancel");
      };
      $scope.isValid = !!$scope.journal.TITLE;
      $scope.isLoading = false;

      $scope.updateFields = function (entity) {
        $scope.isValid = false;
        $scope.isLoading = true;
        Scripts.loadScriptJournalArticlesTextByID(entity.PUBMED_ID, (data, status) => {
          $scope.isValid = status === 200 && data.TITLE;
          $scope.isLoading = false;

          entity.AUTHORS = data.AUTHORS;
          entity.TITLE = data.TITLE;
          entity.REF = data.REF;
          entity.ALIAS = data.ALIAS;
        });
      };
    },
  ]);
